import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/router";
import http from '../http'

Vue.use(Vuex)

const store =  new Vuex.Store({
  state: {
    user: null,
    company: null,
    gLoading: true,
    authLoading: false,
    gError: false
  },
  getters: {
    getCompany: state => state.company,
    getUser: state => state.user,
    getGLoading: state => state.gLoading,
    getAuthLoading: state => state.authLoading,
    getGError: state => state.gError,
  },
  mutations: {
    setCompany: (state,payload) => state.company = payload,
    setUser: (state,payload) => state.user = payload,
    logOut: s => {
      s.company = null
      localStorage.removeItem('token');
      localStorage.removeItem('type');
      localStorage.removeItem('admin');
      router.push({name: 'login'});
    },
    setGLoading: (state,payload) => state.gLoading = payload,
    setAuthLoading: (state,payload) => state.authLoading = payload,
    setGError: (state,payload) => state.gError = payload,
  },
  actions: {
    async fetchCompanyInfo({commit}){
      try{
        commit('setGError', false)
        commit('setGLoading', true)
        const {data} = await http.post('/get-company-info', { token: localStorage.getItem('token') })
        if (data.info) {
          commit('setCompany',data.info)
        } else {
          if (data.error === 'Ошибка авторизации') {
            commit('logOut')
          }
          commit('setGError', true)
        }
      }catch (e){
        commit('setGError', true)
      } finally {
        commit('setGLoading', false)
      }
    },
    async fetchUserInfo({commit}){
      try{
        commit('setGError', false)
        commit('setGLoading', true)
        const {data} = await http.post('/get-user', { token: localStorage.getItem('token') })
        if (data.user) {
          commit('setUser',data.user)
        } else {
          commit('setGError', true)
        }
      }catch (e){
        commit('setGError', true)
      } finally {
        commit('setGLoading', false)
      }
    },
  },
  modules: {
  }
})

export default store
